// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"09a67150","453":"3598b6b6","830":"406aea7c"}[chunkId] + ".chunk.js";
};